import { isOnlyAdmin } from './utils'

/** Where a signed-in user lands when they open the app, sign in, or hit home. */
export function appHomePath(user: any): string {
  if (isOnlyAdmin(user)) return '/admin'
  if (user?.user_type?.toLowerCase() === 'producer') return '/dashboard'
  return '/discover'
}

